const ALLOWED_CARD_TYPE_URI_PROTOCOLS = new Set([
  'http:',
  'https:',
  'line:',
  'tel:',
]);

export function normalizeCardTypeActionUri(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  try {
    const uri = new URL(trimmed);
    if (!ALLOWED_CARD_TYPE_URI_PROTOCOLS.has(uri.protocol.toLowerCase())) {
      return null;
    }
    return encodeURI(uri.href).replace(/%25([0-9a-f]{2})/gi, '%$1');
  } catch {
    return null;
  }
}
